import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { MAINTENANCE_CHECKLIST_PATH } from '../../../../config/paths';
import MaintenanceChecklistForm from './MaintenanceChecklistForm';
import { DATE_TIME_LOCAL } from '../../../../config/locale';
import { tzNormalizeDate } from '../../../../utils/date';
import { postMaintenanceChecklist } from '../../../../actions';

const NewMaintenanceChecklist = ({
  breadcrumbs,
  dispatchPostMaintenanceChecklist,
}) => {
  const onSubmit = (formValues) => {
    const getId = (value) => {
      if (!value) return null;

      if (typeof value === 'number' || typeof value === 'string') {
        return value;
      }

      return value.value || value.id || null;
    };

    const toArray = (value) => {
      if (!value) return [];

      return Array.isArray(value) ? value : [value];
    };

    const additionalOccurrences = toArray(formValues.additionalOccurrences);

    const maintenanceChecklistAdditionalActivityExecutionList =
      additionalOccurrences.map((occurrence) => {
        const maintenanceFailMode = occurrence.maintenanceFailModeId;

        return {
          maintenanceFailModeId: getId(maintenanceFailMode),
          maintenanceFailModeCategoryId: getId(
            occurrence.maintenanceFailModeCategoryId,
          ),
          activityId:
            maintenanceFailMode && maintenanceFailMode.activityId
              ? getId(maintenanceFailMode.activityId)
              : null,
          comment: occurrence.comments || occurrence.comment || '',
          recurrence: getId(occurrence.recurrence),
          maintenanceWarningType: getId(occurrence.maintenanceWarningType),
        };
      });

    const request = {
      registeredBusId: getId(formValues.registeredBusId),
      driverId: getId(formValues.driverId),
      deadline: formValues.date || formValues.deadline || null,
      maintenanceChecklistAdditionalActivityExecutionList,
    };

    dispatchPostMaintenanceChecklist(request);
  };
  const content = (
    <MaintenanceChecklistForm
      onSubmit={onSubmit}
      initialValues={{
        date: tzNormalizeDate({ format: DATE_TIME_LOCAL }),
      }}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Recepción de Mantenimiento"
      subtitle="Crear nueva recepción de mantenimiento"
      content={content}
    />
  );
};

NewMaintenanceChecklist.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostMaintenanceChecklist: PropTypes.func.isRequired,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Recepciones de Mantenimiento',
      href: MAINTENANCE_CHECKLIST_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostMaintenanceChecklist: postMaintenanceChecklist,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewMaintenanceChecklist);
